import { combineReducers } from 'redux';

import project from './project/projectslice';
/* import template from './template/templateSlice';*/
import results from './project/resultsSlice';
import componentiGrafici from './project/componentiGraficiSlice';
import esal from './project/esalSlice';
import esalAircraft from './project/esalSliceAircraft';

export default combineReducers({
    /*   template, */
    project,
    results,
    componentiGrafici,
    esal,
    esalAircraft,
});
